import LitPopup from 'lit-popup';

const elements = Array.from(document.querySelectorAll('[data-lit-popup]'));
const leaveDurationInSeconds = 0.3;
const NO_SCROLL_CLASS = 'no-scroll';

const map = new WeakMap();

function getInstanceByElement(el) {
    return map.get(el);
}

elements.forEach((el) => {
    let _leaveTimeout;
    let _wasBodyLocked = false;

    function _lockBodyScroll() {
        _wasBodyLocked = document.body.classList.contains(NO_SCROLL_CLASS);

        if (!_wasBodyLocked) {
            document.body.classList.add(NO_SCROLL_CLASS);
        }
    }

    function _unlockBodyScroll() {
        if (!_wasBodyLocked) {
            document.body.classList.remove(NO_SCROLL_CLASS);
        }
    }

    const popup = new LitPopup(el.dataset.litPopup, {
        onOpen: () => {
            clearTimeout(_leaveTimeout);
            _lockBodyScroll();
        },
        onClose: () => {
            _leaveTimeout = setTimeout(() => {
                _unlockBodyScroll();
            }, leaveDurationInSeconds * 1000);
        },
        onOpenComplete: (instance) => {
            instance.previousActiveElement?.classList.remove('focus-visible');
        },
    });

    map.set(el, popup);
});

export default { getInstanceByElement };
